import { Stepper as MantineStepper } from "@mantine/core";
import styles from "./stepper.module.scss";
import type { CustomStepperFactory, IProps } from "./stepper.types";
import { componentWrapper } from "../../utilities";
import { Icon } from "../icon";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
/**
 * Stepper component displaying progress through a sequence of steps as EdgeTier-styled numbered
 * pills. A thin wrapper around Mantine's Stepper that applies the shared pill styling; use
 * `Stepper.Step` for each step and `Stepper.Completed` for the completed state.
 * @returns {JSX.Element} The Stepper component.
 */
const Stepper = componentWrapper<CustomStepperFactory, IProps>("Stepper", (props, ref) => {
    const { withSeparator = false, size = "sm", ...otherProps } = props;
    return (
        <MantineStepper
            ref={ref}
            data-with-separator={withSeparator}
            classNames={{
                root: styles["root"],
                steps: styles["steps"],
                step: styles["step"],
                stepIcon: styles["stepIcon"],
                stepLabel: styles["stepLabel"],
                separator: styles["separator"],
            }}
            size={size}
            color="var(--mantine-primary-color-filled)"
            completedIcon={<Icon icon={faCheck} size={size} />}
            {...otherProps}
        />
    );
});

Stepper.Step = MantineStepper.Step;
Stepper.Completed = MantineStepper.Completed;

export { Stepper };
